/* Progressive enhancements only: content and Shopify form submissions work without JavaScript. */
(() => {
  function initFaq(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('#faq-search');
    const rows = [...root.querySelectorAll('.faq-question')];
    const clear = root.querySelector('#faq-clear');
    const reset = root.querySelector('#faq-reset');
    const groups = [...root.querySelectorAll('.faq-group')];
    let category = 'all';
    root.querySelector('.faq-categories').hidden = false;
    root.querySelector('.faq-search').hidden = false;
    const filter = () => {
      const words = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      rows.forEach(row => {
        const text = `${row.textContent} ${row.dataset.keywords || ''}`.toLocaleLowerCase();
        const match = (category === 'all' || row.dataset.topic === category) && words.every(word => text.includes(word));
        row.hidden = !match;
        if (match) count++;
        row.open = match && (words.length > 0 || (count === 1 && category === 'all'));
      });
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('.faq-question')].some(row => !row.hidden); });
      root.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      root.querySelector('#faq-empty').hidden = count !== 0;
      root.querySelector('#faq-result-count').textContent = root.dataset.countLabel.replace('%count%', String(count));
      clear.hidden = !input.value;
    };
    input.addEventListener('input', filter);
    clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    reset.addEventListener('click', () => { category = 'all'; input.value = ''; filter(); input.focus(); });
    root.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', () => { category = button.dataset.category; filter(); }));
    filter();
  }

  function initChart(panel) {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const content = panel.querySelector('[data-size-content]');
    const table = content?.querySelector('table');
    const controls = panel.querySelector('[data-size-units]');
    if (!table || !controls) return;
    const rows = [...table.rows];
    if (rows.length < 2) return;
    const headings = [...rows[0].cells];
    // Only convert a complete recognized inch chart. Unrecognized future page content stays intact.
    if (headings.length !== 4 || !headings.slice(1).every(cell => /\(in\)/i.test(cell.textContent))) return;
    const cells = rows.slice(1).flatMap(row => [...row.cells].slice(1));
    if (!cells.length || rows.slice(1).some(row => row.cells.length !== 4) || !cells.every(cell => /^\d+(?:\.\d+)?$/.test(cell.textContent.trim()))) return;
    cells.forEach(cell => { cell.dataset.originalInches = cell.textContent.trim(); });
    headings.forEach((cell, index) => {
      cell.dataset.originalHeading = cell.textContent.trim();
      if (cell.tagName === 'TH') cell.scope = 'col';
      else { cell.setAttribute('role', 'columnheader'); }
      if (index === 0) return;
    });
    rows.slice(1).forEach(row => {
      if (row.cells[0].tagName === 'TH') row.cells[0].scope = 'row';
      else row.cells[0].setAttribute('role', 'rowheader');
    });
    let caption = table.caption;
    if (!caption) caption = table.createCaption();
    caption.textContent = panel.dataset.captionIn;
    controls.hidden = false;
    controls.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      const cm = button.dataset.unit === 'cm';
      cells.forEach(cell => {
        cell.textContent = cm ? (Number(cell.dataset.originalInches) * 2.54).toFixed(2) : cell.dataset.originalInches;
      });
      headings.forEach((cell, i) => { if (i) cell.textContent = cell.dataset.originalHeading.replace(/\(in\)/i, cm ? '(cm)' : '(in)'); });
      controls.querySelectorAll('[data-unit]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      caption.textContent = cm ? panel.dataset.captionCm : panel.dataset.captionIn;
      panel.querySelector('#unit-note').textContent = cm ? panel.dataset.noteCm : panel.dataset.noteIn;
    }));
  }

  function initPolicies() {
    const nav = document.querySelector('[data-policy-nav]');
    const body = document.querySelector('.shopify-policy__body');
    if (!nav || !body || body.dataset.howReady) return;
    body.dataset.howReady = 'true';
    let headings = [...body.querySelectorAll('h1, h2, h3')];
    let labels = null;
    if (!headings.length) headings = [...body.querySelectorAll('strong')].filter(n => n.textContent.trim().length < 160);
    if (headings.length < 2 && window.location.pathname === nav.dataset.shippingPath) {
      const paragraphs = [...body.querySelectorAll('p')].filter(n => n.textContent.trim());
      const shippingLabels = (nav.dataset.shippingLabels || '').split('|');
      if (paragraphs.length === 3 && shippingLabels.length === 3) { headings = paragraphs; labels = shippingLabels; }
    }
    if (headings.length < 2) return;
    const layout = document.createElement('div'); layout.className = 'how-policy-reading';
    const toc = document.createElement('details'); toc.className = 'how-policy-toc';
    toc.open = window.matchMedia('(min-width:761px)').matches;
    const summary = document.createElement('summary'); summary.textContent = nav.dataset.contentsLabel;
    const list = document.createElement('ul');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `how-policy-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = labels ? labels[index] : heading.textContent.trim();
      item.append(link); list.append(item);
    });
    toc.append(summary, list);
    body.before(layout); layout.append(toc, body);
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-how-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-size-chart]').forEach(initChart);
    initPolicies();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
